/* jshint esversion: 6 */
import React, { lazy, Suspense } from 'react';
import CommonRouter from 'app/components/Routers/CommonRouter.jsx';
import { Route, Navigate } from 'react-router-dom';
const ClientApp = lazy(() => import(/* webpackChunkName: "ClientApp" */ 'app/components/ClientApp/ClientApp.jsx'));
import ClientSocials from 'app/views/Client/ClientSocials.jsx';
import ClientSocialEditor from 'app/views/Client/ClientSocialEditor.jsx';
import ClientAccount from 'app/views/Client/ClientAccount.jsx';
import SocialLogPanel from 'app/components/EditorComponents/SocialLogPanel.jsx';
import ClientSubaccountSelector from 'app/views/Client/ClientSubaccountSelector.jsx';
import RouterError from 'app/components/Routers/RouterError.jsx';
import Loading from 'app/components/common/Loading.jsx';

export default function ClientRouter() {
    let routes = (
        <Route path="/" element={<Suspense fallback={<Loading/>}><ClientApp/></Suspense>} errorElement={<RouterError/>}>
            <Route index element={<ClientSocials/>} handle={() => {return {title: 'Client - Socials: dlvrit'}}}/>
            <Route path="/socials" element={<ClientSocials/>} handle={() => {return {title: 'Client - Socials: dlvrit'}}}>
                <Route path="detail/:socialId" element={<ClientSocials/>} handle={() => {return {title: 'Client - Social Detail: dlvrit'}}}/>
            </Route>
            <Route path="/chooser" element={<ClientSubaccountSelector/>} handle={() => {return {title: 'Client - Subaccounts: dlvrit'}}}/>
            <Route path="/social/:socialId" element={<ClientSocialEditor/>} handle={() => {return {title: 'Client - Social Detail: dlvrit'}}}>
                <Route path="log" element={<SocialLogPanel/>} handle={() => {return {title: 'Client - Social Log: dlvrit'}}}/>
            </Route>
            <Route path="/account" element={<ClientAccount/>} handle={() => {return {title: 'Client - Account: dlvrit'}}}/>
            <Route path="/config/socials" element={<Navigate to="/socials" replace/>}/>
            <Route path="/config/chooser" element={<Navigate to="/chooser" replace/>}/>
            <Route path="/share/automate" element={<Navigate to="/socials" replace/>}/>
        </Route>
    );

    return (
        <CommonRouter routes={routes}/>
    );
}
